import React from 'react';
import { Alert, Button, Typography, Card } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { Paragraph, Title, Text } = Typography;

/**
 * Component for displaying warning when user has negative balance
 */
const NegativeBalanceWarning = ({ balance, onRecharge }) => {
  // Only show if balance is negative
  if (!balance || balance >= 0) {
    return null;
  }

  const absBalance = Math.abs(balance).toFixed(2);
  
  return (
    <Card
      bordered={false}
      style={{ 
        marginBottom: 16,
        borderLeft: '4px solid #ff4d4f',
        backgroundColor: '#fff1f0'
      }}
    >
      <Alert
        message={
          <Title level={4} style={{ margin: 0, color: '#cf1322' }}>
            账号已暂停使用
          </Title>
        }
        description={
          <>
            <Paragraph style={{ fontSize: 16, marginBottom: 10 }}>
              您的账号余额为负 (${absBalance})，系统已暂停服务。
            </Paragraph>
            <Paragraph style={{ fontSize: 16, marginBottom: 16 }}>
              请立即充值以恢复账号功能。如有疑问，请联系管理员。
            </Paragraph>
            <Button 
              type="primary" 
              danger 
              size="large" 
              onClick={onRecharge}
            >
              立即充值
            </Button>
          </>
        }
        type="error"
        showIcon
        icon={<ExclamationCircleOutlined style={{ fontSize: 24 }} />}
        style={{ 
          border: 'none',
          backgroundColor: 'transparent',
          padding: 0
        }}
      />
    </Card>
  );
};

export default NegativeBalanceWarning; 